import React from "react"
import styles from "./AuthenticationError.module.css"
import ClearFix from "../common/ClearFix";

const AuthenticationError = props => {
    const {onRetry, onCancel} = props;

    const onRetryHandler = () => {
        if (onRetry) onRetry();
    }

    const onCancelHandler = () => {
        if (onCancel) onCancel();
    }

    return (
        <div className={styles.container}>
            <span className={styles.wrapper}>
                <div className={styles.error_icon}>
                    <span id={styles.large_icon} className="k-icon k-font-icon k-i-cancel"></span>
                </div>
                <p className={styles.remark}>{"Something went wrong during the authentication phase"}</p>
            <div className={styles.buttonWrapper}>
                <button className={styles.enabled} onClick={onRetryHandler} >
                    Retry
                </button>
                <button className={styles.enabled} onClick={onCancelHandler}> 
                    Logout
                </button>
                <ClearFix />
            </div>
            </span>
        </div>
    );

}

export default AuthenticationError;